import { Button as ButtonSemantic } from '@mairistem/composants';

const Button = (props) => {
  const {
    ...rest
  } = props;

  return (
    <ButtonSemantic
      type="button" // pour éviter le refresh webdev
      {...rest}
    />
  );
};

export default Button;
